/** @deprecated Используйте тип Option из common/types/option.ts */
export default class Option<T extends string | number = string> {
  readonly label: string;
  readonly code: T;
  readonly disabled: boolean;

  constructor(response: any, codeKey: string, labelKey: string, enabledKey?: string) {
    this.code = this.getCode(response, codeKey);
    this.label = this.getLabel(response, labelKey);
    this.disabled = this.getDisabled(response, enabledKey);
  }

  protected getCode(response: any, key: string): T {
    return response[key];
  }

  protected getLabel(response: any, key: string): string {
    return response[key];
  }

  protected getDisabled(response: any, key?: string): boolean {
    return key ? !response[key] : false;
  }
}
